<script setup lang="ts">

import ErrorList from './ErrorList.vue';

import { computed } from 'vue'

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const props = withDefaults(
  defineProps<{
    id?: string
    modelValue?: any
    icon?: any
    label?: string
    placeholder?: string
    errors?: string[]
    type?: string,
    inputClass?: string,
    iconClass?: string,
  }>(),
  { type: 'text', iconClass: 'w-5 h-5' }
)

const onInput = (evt: Event) => {
  emit('update:modelValue', (evt!.target as HTMLInputElement)!.value)
}

const hasErrors = computed(() => props.errors && props.errors?.length > 0)
</script>

<template>
  <label
    :for="props.id"
    :class="{'error': hasErrors}"
    >{{ props.label }}</label
  >
  <div class="flex flex-col mt-2 space-y-2 min-h-[70px]">
    <div
      :class="['form-field', {'error': hasErrors }]"
    >
      <div class="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
        <component :is="icon" v-bind:class="props.iconClass" aria-hidden="true" />
      </div>
      <input
        :type="props.type"
        :id="props.id"
        :value="props.modelValue"
        @input="onInput"
        :placeholder="props.placeholder"
        class="pl-10"
        v-bind:class="props.inputClass"
      />
    </div>
    <ErrorList :errors="props.errors" />
  </div>
</template>
<style scoped></style>
